export const trustchain = 'trustchain';
export const ipScreening = 'ip_screening';
export const deviceScreening = 'device_screening';
